import {getKeyCardRestUrl} from "./url";

export class RestClient {
	constructor(token: string) {
		this.headers = {
			// Our token based authentication
			Authorization: `Basic ${btoa(token + ":")}`,
			// To avoid the WWW-Authenticate header in the response, that would let the browser open
			// its authentication dialog:
			"X-Requested-With": "XMLHttpRequest",
		};
	}

	private readonly headers: HeadersInit;

	async get(endpoint: string) {
		return await window.fetch(getKeyCardRestUrl(endpoint), {
			method: "get",
			headers: this.headers,
		});
	}

	async post(endpoint: string, body: any) {
		return await window.fetch(getKeyCardRestUrl(endpoint), {
			method: "post",
			body: body ? JSON.stringify(body) : undefined,
			headers: {
				"Content-type": "application/json",
				...this.headers,
			},
		});
	}

	async delete(endpoint: string, body?: any) {
		return await window.fetch(getKeyCardRestUrl(endpoint), {
			method: "delete",
			body: body ? JSON.stringify(body) : undefined,
			headers: {
				"Content-type": "application/json",
				...this.headers,
			},
		});
	}
}

export async function getJsonResult<T>(response: Response) {
	if (response.ok) {
		return await response.json() as T;
	}
	else {
		throw new Error("HTTP error: " + response.status);
	}
}
